import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);

  // Load saved login status from localStorage on mount
  useEffect(() => {
    const savedLogin = localStorage.getItem('isAdmin');
    if (savedLogin === 'true') {
      setIsAdmin(true);
    }
  }, []);

  const login = (email, password) => {
    if (email === 'vivekverma942003@gmail.com' && password === 'vivek123') {
      setIsAdmin(true);
      localStorage.setItem('isAdmin', 'true'); // persist login
      return true;
    }
    return false;
  };

  const logout = () => {
    setIsAdmin(false);
    localStorage.removeItem('isAdmin');
  };

  return (
    <AuthContext.Provider value={{ isAdmin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default AuthProvider;
